export default "/dist/files/icone_transports.7bc7f3f4c0947f876a90e0c9b5df200c.svg";